<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <sale-market-head></sale-market-head>
      <div class="row">
        <div class="col-md-5 mt20">
          <a class="btn btn-primary" v-on:click="showModal(null)">{{'Add ad'|translate}}</a>
        </div>
        <div class="col-md-7 mt20">
          <div class="row">
            <div class="col-md-6">
              <select
                class="form-control"
                v-model="search_params.varriant_id"
                @change="doSearch($event)"
              >
                <option value>{{'All varriants'|translate}}</option>
                <option
                  v-for="(varriant) in all_varriants"
                  :key="varriant.id"
                  v-bind:value="varriant.id"
                >{{ varriant.name }} ({{varriant.product_name}})</option>
              </select>
            </div>
            <div class="col-md-6">
              <select
                class="form-control"
                v-model="search_params.store_id"
                @change="doSearch($event)"
              >
                <option value>{{'All stores'|translate}}</option>
                <option
                  v-for="(store) in stores"
                  :key="store.id"
                  v-bind:value="store.id"
                >{{ store.name }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <loading v-if="list_items == null" class="mt20" :text="'Please wait'|translate"></loading>

      <p
        class="mt20 alert alert-info"
        v-if="list_items && list_items.length == 0"
      >{{'There is no data'|translate}}</p>
      <table class="table mt10" v-if="list_items && list_items.length > 0">
        <thead>
          <tr>
            <th>{{'Price'|translate}}</th>
            <th>{{'Store'|translate}}</th>
            <th>{{'Varriant'|translate}}</th>
            <th>{{'Provider'|translate}}</th>
            
            <th>{{'Action'|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item) in list_items" :key="item.id">
            <td>{{ item.price }}</td>
            <td>{{ item.store_name }}</td>
            <td>{{ item.varriant_name }} ({{item.product_name}})</td>
            <td>{{ item.source_name }} ({{item.source_type|translate}})</td>
            <td>
              <router-link
                :to="{ name: 'SaleAdMarketDetail', params: { ad_id: item.id}}"
                class="btn btn-info"
              >{{'View'|translate}}</router-link>
              <a
                class="btn btn-danger"
                v-on:click="removeItem(item)"
                :disabled="removing"
              >{{'Delete'|translate}}</a>

              <a class="btn btn-info" v-on:click="showModal(item)">{{'Update'|translate}}</a>
            </td>
          </tr>
        </tbody>
      </table>
      <paginate
        v-if="total_page > 1"
        :page-count="total_page"
        :click-handler="clickPage"
        :prev-text="'Prev'|translate"
        :next-text="'Next'|translate"
        v-model="page"
        :container-class="'pagination'"
      ></paginate>
    </div>
    <form-sale-ad
      v-if="show_form"
      ref="work_form"
      :all_varriants="all_varriants"
      :stores="stores"
      :pass_data="pass_data"
      @modalData="modalData"
    ></form-sale-ad>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import FormSaleAd from "@/components/forms/FormSaleAd";
import Paginate from "vuejs-paginate";
import Loading from "@/components/elements/Loading";
import SaleMarketHead from "@/components/SaleMarket/SaleMarketHead";
export default {
  name: "Home",
  components: {
    MyHeader,
    Paginate,
    Loading,
    FormSaleAd,
    SaleMarketHead
  },
  data() {
    return {
      show_form: false,
      pass_data: null,
      all_varriants: [],
      stores: [],
      list_items: null,
      removing: false,
      page: 1,
      offset: 0,
      search_params: {
        store_id: "",
        varriant_id: ""
      },
      limit: Utils.getLimit(),
      total_page: 1
    };
  },
  methods: {
    modalData(data) {
      
      this.list();
    },
    showModal(data) {
      if (this.all_varriants.length == 0) {
        // return this.$alertify.notify(this.$t(""));
        return Utils.showError( this,this.$t("Wating for data"))
      }
      if (this.stores.length == 0) {
        return Utils.showError( this,this.$t("You need add more store before use this function"))
       
      }
      this.show_form = true;
      this.pass_data = data != null ? JSON.parse(JSON.stringify(data)) : data;

      setTimeout(() => {
        this.$refs.work_form.open();
      }, 100);
    },
    promiseList() {
      let data = {
        offset: this.offset,
        limit: this.limit
      };
      if (this.search_params.store_id) {
        data.store_id = this.search_params.store_id;
      }
      if (this.search_params.varriant_id) {
        data.varriant_id = this.search_params.varriant_id;
      }
      console.log("data", data);
      return Utils.request(this, true, "salemarket").get(
        `/manageAds?${Utils.arrayToRequestParam(data)}`
      );
    },
    doSearch(event) {
      this.list_items = null;
      this.list();
      this.offset = 0;
    },
    list() {
      this.promiseList()
        .then(response => {
          let data = response.data;
          //
          this.processList(data);
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    processList(data) {
      if (data.status === "ok") {
        
        let list = data.data.list;
        list = list.map(item => {
          let temp = new Date(parseInt(item.add_time) * 1000);
          item.add_date = this.$moment(temp);

          let temp1 = new Date(parseInt(item.start_time) * 1000);
          item.start_date = this.$moment(temp1);
          item.remain_text = Utils.getFormattedTime(this, item.add_date);
          return item;
        });
        this.list_items = list;
        
        this.total_page = Utils.getTotalPages(data.data.total);
        
        // update local storage
      }
    },
    removeItem(item) {
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        this.$t("Are you sure to remove this item ?"),
        () => {
          this.removing = true;
          Utils.request(this, true, "salemarket")
            .delete(`/manageAds?id=${item.id}`)
            .then(response => {
              this.removing = false;
              let data = response.data;
              if (data.status === "ok") {
                this.offset = 0;
                this.list();
              }
            });
        }
      );
    },
    clickPage(pageNum) {
      
      this.offset = Utils.getNextOffset(pageNum);
      this.list();
    },
    search() {
      
      this.offset = 0;
      this.list();
    },
    getVarriants() {
      Utils.request(this, true, "salemarket")
        .get(`/getVarriants/`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
          }
        });
    }
  },
  mounted() {
    let data = {
      offset: 0,
      limit: -1
    };
    let wating = [
      Utils.request(this, true, "store").get(
        `/manageStore/?${Utils.arrayToRequestParam(data)}`
      )
    ];
    wating.push(Utils.request(this, true, "salemarket").get(`/getVarriants/`));
    wating.push(this.promiseList());
    Promise.all(wating).then(values => {
      this.all_varriants = values[1].data.data;
      this.stores = values[0].data.data.list;
      this.processList(values[2]);
      console.log("stores", this.stores);
      console.log("all_varriants", this.all_varriants);
    });

    this.list();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SaleMarket/ManageSaleMarket.vue